import { Box, Grid, Typography } from "@mui/material";
import FormField from "components/FormField";
import SelectField from "components/SelectField";
import { memo } from "react";
import DatepickerField from "components/DatepickerField";
import SwitchField from "components/SwitchField";
import FormNumberField from "components/FormNumberField";

/* eslint-disable react/prop-types */

function Fields2({ formData }) {
  const { formField2, values, errors, touched } = formData;
  const {
    quarter,
    year,
    name,
    taxId
  } =
    formField2;
  return (
    <Box display="flex" flexDirection="column" gap={1}>
      <Grid spacing={3} container>
      <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormNumberField
            name={quarter.name}
            label={quarter.label}
            value={values.quarter}
            error={errors.quarter && touched.quarter}
            success={values.quarter?.toString().length > 0 && !errors.quarter}
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormNumberField
            name={year.name}
            label={year.label}
            value={values.year}
            error={errors.year && touched.year}
            success={values.year?.toString().length > 0 && !errors.year}
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            name={name.name}
            label={name.label}
            value={values.name}
            error={errors.name && touched.name}
            success={
              values.name?.toString().length > 0 && !errors.name
            }
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            name={taxId.name}
            label={taxId.label}
            value={values.taxId}
            error={errors.taxId && touched.taxId}
            success={
              values.taxId?.toString().length > 0 && !errors.taxId
            }
          />
        </Grid>
      </Grid>
    </Box>
  );
}

export default memo(Fields2);
